define('controllers/myaccountlinks',['require'],function(require) {
	return function() {
		//figure out where we are...
		var location = window.location.toString().toLowerCase(),
			anchors = $("#ctl00_ctl00_MainClump_CPHMain_AccountMenu1_Container a"),
			anchorHrefs = [];

		anchors.each(function () {
			anchorHrefs.push($(this).attr("href"));
		});

		anchorHrefs.sort(function (a, b) {
			return b.length - a.length; // ASC -> a - b; DESC -> b - a
		}); //sort to get longest, since we're finding with contains. (get closest match)

		for (var i = 0, length = anchorHrefs.length; i < length; i++) {
			var href = anchorHrefs[i],
				contains = location.indexOf(href.toLowerCase()) != -1;

			if (contains) {
				var anchor = $("#ctl00_ctl00_MainClump_CPHMain_AccountMenu1_Container a[href='{0}']".format(href));
				anchor.parent().addClass("active");
				return 1; //break out when found...
			}
		}
	};
});
